export default __webpack_public_path__ + "static/media/privacy-verklaring.c9c79434.pdf";